import { TYPES } from 'action-types/partners';
import {
    IPartnersModel,
} from 'reducers/partners/models';
import * as msgs from '../../constants/validationMessages';

export interface IPartnersAction {
    readonly type: string;
    readonly errors?: string|string[];
    readonly partners: IPartnersModel;
}

export interface IPartnersState {
    readonly isFetchDataLoading: boolean;
    readonly isFetchDataError: boolean;
    readonly pendingError: string | string[];
    readonly partners: any;
}

export const defaultState: IPartnersState = {
    isFetchDataError:false,
    pendingError: '',
    isFetchDataLoading: false,
    partners: {
        page: 1,
        pageSize: 0,
        totalCount: 0,
        result: []
    },
};

export const reducer = (state: IPartnersState = defaultState, action: IPartnersAction): IPartnersState => {
    switch (action.type) {
        case TYPES.RESET_PARTNERS.PENDING:
        case TYPES.FETCH_PARTNERS.PENDING:
            return {
                ...state,
                partners: defaultState.partners,
                isFetchDataLoading: true,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.FETCH_PARTNERS.FULFILLED:
            return {
                ...state,
                partners: action.partners,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: action.partners && action.partners.result.length>0?'':msgs.ExtraDocument.Pending_Error
            };
        case TYPES.FETCH_PARTNERS.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError:action.errors && action.errors.length ?action.errors.toString(): msgs.ExtraDocument.Error_Msg
            };
        default:
            return state;
    }
};
